"use client";

import injectedWallets from "@web3-onboard/injected-wallets";
import { init, Web3OnboardProvider } from "@web3-onboard/react";
import walletConnect from "@web3-onboard/walletconnect";
import { FunctionComponent, PropsWithChildren } from "react";

import { Header } from "@/components";
import { CHAINS } from "@/constants";
import { LogoStr } from "@/icons";

import styles from "./Layout.module.css";

const web3Onboard = init({
  appMetadata: {
    description: "Please select a wallet to connect.",
    icon: LogoStr,
    name: "AI DeFi",
    recommendedInjectedWallets: [
      {
        name: "MetaMask",
        url: "https://metamask.io",
      },
    ],
  },
  chains: CHAINS.map(({ id, title, token, url }) => ({
    id: Number(id),
    label: title,
    rpcUrl: url,
    token,
  })),
  wallets: [
    injectedWallets(),
    walletConnect({
      dappUrl: "https://aidefi.netlify.app/", // @todo production url
      projectId: "aee076a554653f1d1167cab5235341ad",
    }),
  ],
});

export const Layout: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <Web3OnboardProvider web3Onboard={web3Onboard}>
    <div className={styles.root}>
      <Header />
      <main className={styles.main}>{children}</main>
    </div>
  </Web3OnboardProvider>
);
